import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {Tag} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<Tag, 'id'>,
    handleSubmit: (values: Tag) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: Tag) => {
        handleSubmit(values);
        navigate('/tags');
    };

    const onCancel = () => {
        navigate('/tags');
    };


    let initialValues = {} as Tag;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent {...rest} />
                </FormWithButtons>)}
        </Formik>
    );
};

